
  import { Vue, Prop, Component } from "vue-property-decorator";
  import PostListItem from "@/components/PostListItem.vue";
  import PostSelected from "@/components/PostSelected.vue";
  import FormReplyToAd from "@/components/FormReplyToAd.vue";
  import FormEmailToFriend from "@/components/FormEmailToFriend.vue";
  import { PostService } from "@/services";
  import { IAdsModel } from "@/models";
  import { getModule } from "vuex-module-decorators";
  import { Auth } from "@/store/modules/AuthModule";
  import store from "@/store";

  const AuthModule = getModule(Auth, store);

  @Component({
    name: "PageShowItem",
    components: { FormEmailToFriend, FormReplyToAd, PostSelected, PostListItem }
  })
  export default class PageShowItem extends Vue {
    @Prop() item!: Object;
    @Prop() adId!: number;
    publicPath: string = process.env.BASE_URL as string;
    data: IAdsModel;
    selectedAd: any = null;
    isLoading: boolean = false;
    password: string = "";

    created() {
      // get query from link, fetch pw => ad password
      this.password = (this.$route.query.pw || "") as string;

      if (this.adId) {
        this.getAdvertisement(this.adId);
        return;
      }
    }
    async getAdvertisement(adId: number) {
      this.isLoading = true;
      const response = await PostService.GetDetail(adId);
      if (response.status === 200) {
        this.data = response.data;
      }
      this.isLoading = false;
    }

    get isAdFound() {
      return this.data !== undefined;
    }
    get isAllowedToEdit() {
      if (this.data) {
        if (AuthModule.isAdmin) {
          return true;
        }
        return this.data.password === this.password;
      }
      return false;
    }
    onCallbackReplyEmail(success: boolean) {
      this.$bvModal.hide("reply-to-ad");
      if (success) {
        this.$modal.show("Email has been sent successfully", "success");
      } else {
        this.$modal.show("Failed sent email", "error");
      }
    }
    onCallbackSendEmail(success: boolean) {
      this.$bvModal.hide("email-to-friend");
      if (success) {
        this.$modal.show("Email has been sent successfully", "success");
      } else {
        this.$modal.show("Failed sent email", "error");
      }
    }
    getSelectedAd(value: any) {
      this.selectedAd = value;
    }
    printSelectedAd(value: any) {
      this.selectedAd = value;
      setTimeout(() => {
        this.$htmlToPaper("printcontainer", () => {
          this.$bvModal.hide("print-ad");
        });
      }, 1000);
    }
    deleteSelectedAd(value: any) {
      this.selectedAd = value;
      this.$bvModal.show("delete-modal");
    }
    editSelectedAd(value: any) {
      this.$router.push({
        path: "/PostNewAd",
        query: {
          adId: value.adId.toString(),
          pw: value.password
        }
      });
    }
    async extendSelectedAd(value: any){
      const { adId, password } = value;
      this.$mainLoader.show();
      var response = await PostService.Extend(adId, password);
      if (response.status === 200) {
        this.$modal.show("Your ad has been extended", "success");
        
      } else {
        this.$modal.show("Failed to extended ad", "error");
      }
      this.$mainLoader.hide();
    }
    async handleDelete() {
      var response = await PostService.Delete(this.adId);
      if (response.status === 200) {
        this.$modal.show("Ad has been deleted successfully", "success");
        setTimeout(() => {
          this.$router.push({ name: "Home" });
        }, 1000);
      } else {
        this.$modal.show("Failed delete ad", "error");
      }
    }
    get detail() {
      if (this.adId) {
        return this.data;
      }
      return this.item;
    }
  }
